/**
 * Whether this runtime adds printers through the desktop Star LAN flow
 * (`LanPrinterDialog`: automatic discovery or add by IP → check → test page →
 * save). A **capability** question, answered from the printing capability —
 * never from a platform string (CLAUDE.md, `src/platform/`).
 *
 * Every desktop "add a printer" entry point routes on this one function, so
 * Electron has exactly one flow and mobile keeps its SDK list untouched.
 */
import type { RuntimeCapabilities } from 'src/platform/types';

export function usesDesktopLanSetup(
  thermalPrinting: RuntimeCapabilities['thermalPrinting']
): boolean {
  return thermalPrinting === 'star-electron-lan';
}
